

// src/hooks/useNewsletter.js
// -----------------------------------------------------------------------------
// React hook to subscribe a visitor to the newsletter.
// • Re‑uses geo/IP data from useGeoInfo (no extra network call).
// • Returns { status , subscribe }.
//   status: 'idle' | 'loading' | 'success' | 'error'
//   subscribe({ email, name? }) triggers the POST → subscribe.php
// • Endpoint is read from VITE_API_URL (fallback provided).
// -----------------------------------------------------------------------------

import { useState } from 'react';
import axios        from 'axios';
import useGeoInfo   from '../useGeoInfo.js';

// build URL once
const BASE = 'https://system.yousrygroup.com/api_test/php';
const ENDPOINT = `${BASE}/subscribe.php`;

/* -------------------------------------------------------------------------- */
export default function useNewsletter() {
  const geo = useGeoInfo();
  const [status, setStatus] = useState('idle'); // idle | loading | success | error
  const account  = "Online";
  const platform = "Google";
  /** subscribe({ email, name? }) → void */
  const subscribe = async ({ email, name = '' }) => {
    if (!email) return setStatus('error');

    setStatus('loading');

    try {
      await axios.post(ENDPOINT, {
        account,
        platform,
        email,
        name,
        ip:       geo.ip,
        ip2:     geo.ip,
        lat:      geo.lat,
        lng:      geo.lng,
        country:  geo.country,
        city:     geo.city,
        region:   geo.region,
      });

      setStatus('success');
    } catch (err) {
      console.error('newsletter‑subscribe failed', err);
      setStatus('error');
    }
  };

  return { status, subscribe };
}
